import React from "react";
import ReactMarkdown from "react-markdown";
import { useFetchMarkdown } from "hooks";

export default () => (
  <ReactMarkdown source={useFetchMarkdown(require("doc/attribution/ios.md"))} />
);
